import { createFileRoute } from "@tanstack/react-router";
import { CategoryImagesPage } from "@/pages/admin-category-images/ui/category-images-page";

export const Route = createFileRoute(
  "/_authed/$companySlug/admin/category-images",
)({
  component: CategoryImagesPage,
});
